import React from 'react';
import AvatarBuilder from '../components/AvatarBuilder';

export default function EditAvatar() {
  return <AvatarBuilder mode="edit" />;
}
